import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { label: "About", href: "#about" },
  { label: "Pillars", href: "#pillars" },
  { label: "Location", href: "#location" },
  { label: "A Day", href: "#day" },
  { label: "Quiz", href: "#quiz" },
  { label: "Retreats", href: "#retreats" },
  { label: "Contact", href: "#contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-40 transition-colors duration-500 ${
        scrolled ? "bg-sand/90 backdrop-blur-md border-b border-line" : "bg-transparent"
      }`}
    >
      <nav className="max-w-[1400px] mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        <a href="#top" data-testid="logo" className="font-serif text-2xl tracking-tight text-forest leading-none">
          Sound Body<span className="block text-[0.6rem] tracking-[0.4em] uppercase font-sans text-muted -mt-1">retreat</span>
        </a>

        <div className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="text-sm text-ink/80 hover:text-forest transition-colors tracking-wide"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#retreats"
            data-testid="nav-book-btn"
            className="rounded-full bg-forest text-sand px-6 py-2.5 text-sm hover:bg-forest-deep transition-colors"
          >
            Book a Retreat
          </a>
        </div>

        <button
          className="md:hidden text-forest"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
        >
          {open ? <X /> : <Menu />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden bg-sand border-t border-line px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-base text-ink"
              data-testid={`mobile-nav-${l.label.toLowerCase()}`}
            >
              {l.label}
            </a>
          ))}
          <a href="#retreats" onClick={() => setOpen(false)} className="rounded-full bg-forest text-sand px-6 py-3 text-center">
            Book a Retreat
          </a>
        </div>
      )}
    </header>
  );
};
